export var ManualNotificationQueuesStatusType;
(function (ManualNotificationQueuesStatusType) {
    ManualNotificationQueuesStatusType["WAITING"] = "waiting";
    ManualNotificationQueuesStatusType["PROCESSING"] = "processing";
    ManualNotificationQueuesStatusType["FAILED"] = "failed";
})(ManualNotificationQueuesStatusType || (ManualNotificationQueuesStatusType = {}));
//# sourceMappingURL=ManualNotificationQueuesStatusType.js.map